import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var PhoneOn = createIcon({
  displayName: 'PhoneOn',
  viewBox: '0 0 24 24',
  path: [/*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.9 4c.3.2 1 .8 1.4 1.6.4.6.7 1.4.7 1.7 0 .2-.3.7-.5 1-.5.8-.9 1.6-.8 2.4.1.4.5 1.6 1.9 3s2.6 1.8 3 1.9h.3c.7 0 1.4-.4 2.1-.8.3-.2.8-.5 1-.5.4 0 1.2.4 1.7.7.7.5 1.4 1.1 1.6 1.4-.2.6-2 2.4-3.5 2.8-.2.1-.4.1-.6.1-2 0-5-2.2-7-4.3C7 12.9 4.5 9.5 5.1 7.5 5.5 6 7.3 4.2 7.9 4zM8 3C6.9 3 4.7 5.4 4.1 7.2c-.8 2.8 2.7 6.9 4.4 8.6 1.6 1.6 5 4.6 7.7 4.6.3 0 .6 0 .9-.1 1.9-.6 4.5-3 4.2-4-.3-.9-1.9-2-2-2.1-.1-.1-1.4-.9-2.2-.9h-.2c-.8.1-2.2 1.3-2.9 1.3h-.1c-.5-.1-1.5-.5-2.5-1.6-1.1-1.1-1.5-2-1.6-2.5-.2-.7 1.2-2.2 1.3-3 .1-.8-.8-2.2-.9-2.4-.1-.2-1.1-1.8-2.1-2C8.1 3 8 3 8 3z",
    clipRule: "evenodd"
  })]
});
//# sourceMappingURL=PhoneOn.js.map